//npm install @mui/icons-material

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
// import ChartApp from './ChartApp';
import App from "./App";
import { Provider } from "react-redux";
import store from "./datastore/store";
import SocketContext, { socket } from "./context/create-context";

ReactDOM.render(
  <Provider store={store()}>
    <SocketContext.Provider value={socket}>
      <App />
    </SocketContext.Provider>
  </Provider>,
  document.getElementById("root")
);
